import React from 'react'

import { Helmet } from 'react-helmet'

import TopMenu from '../components/top-menu'
import Footer from '../components/footer'
import './assets-img.css'

const AssetsImg = (props) => {
  return (
    <div className="assets-img-container1">
      <Helmet>
        <title>Project Assets | Vlad Butucariu</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta
          name="description"
          content="Internal project asset gallery for Vlad Butucariu."
        />
        <meta
          property="og:title"
          content="Project Assets | Vlad Butucariu"
        />
        <meta
          property="og:description"
          content="Internal project asset gallery for Vlad Butucariu."
        />
        <meta
          property="og:image"
          content="https://vladbutucariu.com/Images/og-assets.png"
        />
        <link rel="canonical" href="https://vladbutucariu.com/assets-img" />
        <meta
          property="og:url"
          content="https://vladbutucariu.com/assets-img"
        />
      </Helmet>
      <div className="assets-img-thq-wrapper-elm">
        <TopMenu></TopMenu>
        <div className="assets-img-thq-top-section-elm">
          <div className="assets-img-thq-video-div-elm">
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="assets-img-video"
            ></video>
            <video
              src="/Video/irreversible-blob-bg-1780402436590.mp4"
              loop
              muted
              autoPlay
              className="assets-img-thq-video-mobile-elm"
            ></video>
          </div>
          <div className="assets-img-thq-section-elm1">
            <div className="assets-img-thq-color-wrapper-elm">
              <div className="assets-img-thq-container-elm">
                <div className="itemBox">
                  <img
                    alt="image"
                    src="/assets/badge-tkr.png"
                    className="assets-img-image10"
                  />
                </div>
                <div className="itemBox">
                  <img
                    alt="image"
                    src="/assets/tickerstkn.png"
                    className="assets-img-image11"
                  />
                </div>
                <div className="itemBox">
                  <img
                    alt="image"
                    src="/assets/tkr-badges-icon.png"
                    className="assets-img-image12"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="assets-img-thq-section-elm2">
          <div className="assets-img-thq-label-elm">
            <span className="assets-img-text3">Loopers</span>
            <span className="assets-img-text4">
              animation, nft, collection, art
            </span>
          </div>
          <div className="assets-img-container5">
            <div className="assets-img-thq-item-elm13">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="assets-img-image13"
              />
            </div>
            <div className="assets-img-thq-item-elm14">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="assets-img-image14"
              />
            </div>
            <div className="assets-img-thq-item-elm15">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="assets-img-image15"
              />
            </div>
            <div className="assets-img-thq-item-elm16">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="assets-img-image16"
              />
            </div>
            <div className="assets-img-thq-item-elm17">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="assets-img-image17"
              />
            </div>
            <div className="assets-img-thq-item-elm18">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="assets-img-image18"
              />
            </div>
            <div className="assets-img-thq-item-elm19">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="assets-img-image19"
              />
            </div>
            <div className="assets-img-thq-item-elm20">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="assets-img-image20"
              />
            </div>
            <div className="assets-img-thq-item-elm21">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="assets-img-image21"
              />
            </div>
            <div className="assets-img-thq-item-elm22">
              <img
                alt="image"
                src="/Images/alwayslate2.svg"
                className="assets-img-image22"
              />
            </div>
            <div className="assets-img-thq-item-elm23">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="assets-img-image23"
              />
            </div>
            <div className="assets-img-thq-item-elm24">
              <img
                alt="image"
                src="/Images/alwayslate4.svg"
                className="assets-img-image24"
              />
            </div>
            <div className="assets-img-thq-item-elm25">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="assets-img-image25"
              />
            </div>
            <div className="assets-img-thq-item-elm26">
              <img
                alt="image"
                src="/Images/alwayslate6.svg"
                className="assets-img-image26"
              />
            </div>
            <div className="assets-img-thq-item-elm27">
              <img
                alt="image"
                src="/Images/alwayslate3.svg"
                className="assets-img-image27"
              />
            </div>
            <div className="assets-img-thq-item-elm28">
              <img
                alt="image"
                src="/Images/alwayslate5.svg"
                className="assets-img-image28"
              />
            </div>
            <div className="assets-img-thq-item-elm29">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="assets-img-image29"
              />
            </div>
            <div className="assets-img-thq-item-elm30">
              <img
                alt="image"
                src="/Images/alwayslate1.svg"
                className="assets-img-image30"
              />
            </div>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </div>
  )
}

export default AssetsImg
